import { MentionedGroupSuggestion } from "@components/chat/channel/trigger/hooks/useMentionTrigger"
import React, {
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  useCallback,
  useContext,
  useState,
} from "react"

export type MentionedGroupsContextValue = {
  mentionedGroups: MentionedGroupSuggestion[]
  setMentionedGroups: Dispatch<SetStateAction<MentionedGroupSuggestion[]>>
  containsMentionedGroups: (text: string) => boolean
}

const MentionedGroupsContext = React.createContext<MentionedGroupsContextValue>({
  mentionedGroups: [],
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setMentionedGroups: () => {},
  containsMentionedGroups: () => false,
})

export function useMentionedGroups() {
  const context = useContext(MentionedGroupsContext)
  if (!context) {
    throw Error("Must be used within MentionedGroupsProvider")
  }

  return context
}

const MentionedGroupsProvider: FC<{ children?: ReactNode }> = (props) => {
  const { children } = props
  const [mentionedGroups, setMentionedGroups] = useState<MentionedGroupSuggestion[]>([])

  const containsMentionedGroups = useCallback((text: string) => {
    // Check if there's still at channel mentions in the message
    const matches = text.match(new RegExp(`@channel`, "g"))

    return Boolean(matches?.length)
  }, [])

  return (
    <MentionedGroupsContext.Provider
      value={{
        mentionedGroups,
        setMentionedGroups,
        containsMentionedGroups,
      }}
    >
      {children}
    </MentionedGroupsContext.Provider>
  )
}

export default MentionedGroupsProvider
